<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'edit_window_type' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">
    <!-- <h2 class="modal-title">{{'edit_window_type' | translate}}</h2> -->

    <div>
      <div class="image-container">
        <img [src]="this.selectedWindowType?.img" />
      </div>
      <div class="form-container">
        <div class="input-group">
          <ion-label class="input-label">{{'HEADER_WIDTH_A' | translate}}</ion-label>
          <ion-input class="bordered-input" type="tel" inputmode="numeric" [(ngModel)]="dimensionForm.dimA" name="dimA"
            (ionInput)="onDimensionInput('dimA', $event)" (ionBlur)="validateForm()">
          </ion-input>
        </div>

        <div class="input-group">
          <ion-label class="input-label">{{'HEADER_HEIGHT_B' | translate}}</ion-label>
          <ion-input class="bordered-input" type="tel" inputmode="numeric" [(ngModel)]="dimensionForm.dimB" name="dimB"
            (ionInput)="onDimensionInput('dimB', $event)" (ionBlur)="validateForm()">
          </ion-input>
        </div>

        <div class="input-group" *ngIf="showHeightC">
          <ion-label class="input-label">{{'HEADER_HEIGHT_C' | translate}}</ion-label>
          <ion-input class="bordered-input" type="tel" inputmode="numeric" [(ngModel)]="dimensionForm.dimC" name="dimC"
            (ionInput)="onDimensionInput('dimC', $event)" (ionBlur)="validateForm()">
          </ion-input>
        </div>

      </div>
    </div>
  </div>
</ion-content>
<ion-footer [translucent]="false" class="ion-no-border ">
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="cancel()" expand="block">
      {{'back' | translate}}
    </ion-button>
    <ion-button class="next-btn" (click)="next()" [disabled]="!isFormValid" expand="block">
      {{'validate' | translate}}
    </ion-button>
  </div>
</ion-footer>